import React from 'react';
import { STEPS_CONFIG, TOTAL_STEPS } from '../../constants/formConstants';

const MobileProgress = ({ currentStep }) => {
  return (
    <div className="mpf-mobile-progress d-md-none">
      <div className="mpf-progress-bar">
        <div 
          className="mpf-progress-fill" 
          style={{ width: `${(currentStep / TOTAL_STEPS) * 100}%` }}
        />
      </div>
      <div className="mpf-step-info">
        <span className="mpf-step-title">{STEPS_CONFIG[currentStep - 1]?.title}</span>
        <span>Etapa {currentStep} de {TOTAL_STEPS}</span>
      </div>
    </div>
  );
};

export default MobileProgress;